import { Main } from 'components/template/blog-post/header';
import { Layout } from 'components/layout';
import { CustomMetadata } from 'components/metadata';
import { IBlogPost, IComment } from 'constants/types';
import styles from './styles.module.css';

import { useLazyCommentsQuery } from 'hooks/api/publication-comments';

import { Anchor } from 'constants/anchors';
import { allMetadata } from 'constants/metadata';
import { CommentPublication } from '../publication/comment';
import { WriteComment } from '../publication/write-comment';
import { OtherPosts } from './other-posts';
import { Post } from './post';
import { FAQComponent } from 'components/casino-faq';

interface BlogPostPageProps {
  post: IBlogPost;
  comments: IComment[];
}

export const BlogPostPage = ({ post, comments }: BlogPostPageProps) => {
  const [fetchComment, { data, isFetching, isError }] = useLazyCommentsQuery();

  if (!post) {
    return <div>Not found post</div>;
  }

  const handleAddComment = () => {
    if (!isFetching && !isError) {
      fetchComment({
        id: post?._id,
      });
    }
  };
  const publicationComments =
    data && data.results.length > comments.length ? data.results : comments;

  return (
    <div className={styles.container}>
      <CustomMetadata metadata={allMetadata.blogPost(post)} />
      <Layout hasFooter isSearchInputMobileVisible>
        <Main name={post.title} type={post.type} />
        <Post data={post} />
        <OtherPosts post={post} />
        <div className={styles.comments}>
          {publicationComments.map((el, index) => (
            <CommentPublication
              key={index}
              data={el}
              likeCount={el.likes ? el.likes : 0}
              useReply={false}
            />
          ))}
        </div>
        <div className={styles.write_comment}>
          <WriteComment
            variant="publication"
            parent={post._id?.toString()}
            onCommentAdded={handleAddComment}
            anchor={Anchor.WriteComment}
          />
        </div>

        <div className={styles.faq}>
          <FAQComponent customFaq={post.faq} />
        </div>
      </Layout>
    </div>
  );
};
